
const initialState ={
  rerender:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case "REQUEST_INDEX_INVOICES_SUCCESS":
      newState.invoices=action.val
      newState.rerender=newState.rerender+1
    break;
    case "REQUEST_INDEX_CREDIT_CONSUMPTION_SUCCESS":
      newState.credit_consumption=action.val;
      newState.rerender=newState.rerender+1;
    }
  return newState;
}

export default reducer;
